import React from 'react'
import { Header } from '../Layout'
// import { IntegralRuleModal } from './IntegralRuleModal'
import { Dialog } from 'antd-mobile'

// class IntegralHeader extends React.PureComponent {
//   state = {
//     modalVisible: false
//   }
//
//   render () {
//     return <Header right={<i className={'icon-font icon-help'} onClick={this.openModal}/>}>
//       <span>{this.props.children}</span>
//       <IntegralRuleModal visible={this.state.modalVisible} onClose={this.closeModal}/>
//     </Header>
//   }
//
//   openModal = () => {
//     this.setState({ modalVisible: true })
//   }
//
//   closeModal = () => {
//     this.setState({ modalVisible: false })
//   }
// }

const IntegralHeader = ({ children }) => {
  const openDialog = () => {
    Dialog.alert({
      title: '关于积分商城',
      content: <div>
        <p>1.签到获积分：进入【任务中心】-【签到打卡】进行每日打卡获取积分；</p>
        <p>2.交易获积分：进入【下单】页面现金订购后可获取积分；</p>
        <p>3.晒单获积分：参与晒单瓜分巨额积分；</p>
        <p>4.更多途径：敬请关注首页活动；</p>
        <p>5.积分商城所有兑换物与兑换积分不定期调整，先兑先得，兑完即止。</p>
        <p>以上内容所有解释权归平台所有</p>
      </div>
    }).finally()
  }
  return <Header right={<i className={'icon-font icon-help'} onClick={openDialog}/>}>
    <span>{children}</span>
  </Header>
}

export { IntegralHeader }
